<template>
  <div>
    <component
      v-if="applicantRightholder"
      :is="Form"
      :loading-next="loadingNext"
      @prev="$emit(StepDirection.PREV, $event)"
      @next="$emit(StepDirection.NEXT, $event)"
    ></component>
    <div v-else>
      <section class="section-base form-section-base">
        <div class="form-section-base__title">
          Шаг заявления заполняется если требуется указать сведения о заявителе,
          являющимся правообладателем объекта недвижимости или лицом, в пользу
          которого зарегистрированы ограничения или обременения в отношении
          объекта недвижимости
        </div>

        <v-container>
          <div class="form-base">
            <Footer
              @next-btn-click="btnSaveClickHandler(StepDirection.NEXT)"
              @prev-btn-click="btnSaveClickHandler(StepDirection.PREV)"
              :loading-next="loadingNext"
            />
          </div>
        </v-container>
      </section>
    </div>
  </div>
</template>

<script>
import Manual from './Manual';
import Machine from './Machine';
import { ServicesModule } from '@/store/modules/services';
import { SubjectFillType } from '@/constants';
import { StepDirection, StepName } from '@/types/services';
import { leaveStep } from '@/utils/services';
import Footer from '@/components/services/elements/Footer';

export default {
  name: 'ApplicantRightholderMrpa',
  components: {
    Footer,
  },
  props: {
    loadingNext: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    StepDirection,
    invalidFields: [],
  }),
  computed: {
    Form() {
      const fillType =
        ServicesModule.statement.subjects.applicantRightholder?.uiContext
          ?.fillType;

      if (fillType === SubjectFillType.MACHINE) return Machine;

      return Manual;
    },

    applicantRightholder() {
      return ServicesModule.statement.subjects.applicantRightholder;
    },
  },
  methods: {
    assemblyModel() {
      return null;
    },

    async touchFields() {},

    btnSaveClickHandler(direction) {
      leaveStep({
        stepThis: this,
        direction,
        step: StepName.S4,
      });
    },
  },
};
</script>
